module.exports = __webpack_public_path__ + "static/media/conferencia-maria-garcia-fleury.b103cf91.png";